import { createContext, RefObject, useContext, useRef } from "react";

const MountTimestampContext = createContext<RefObject<number> | null>(null);
export const useMountTimestamp = () => {
  return useContext(MountTimestampContext);
};

export const MountTimestampProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const mountTimestampRef = useRef(Date.now());

  console.log("///", mountTimestampRef.current);
  return (
    <MountTimestampContext.Provider value={mountTimestampRef}>
      {children}
    </MountTimestampContext.Provider>
  );
};
